import { milestoneRewardImages } from '~/assets/rewards'
import { m } from '~/paraglide/messages'
import type { NominalReward } from './delivery'

/**
 * The visual a reward milestone shows. The backend owns only
 * "threshold -> item_type_id"; the client hardcodes the five rewards'
 * visuals by milestone position (see CONTEXT.md "Reward milestone").
 */
export type RewardVisual =
  | { kind: 'coins'; amount: number }
  | { kind: 'gems'; amount: number }
  | { kind: 'content'; name: string }

// The five rewards of the Figma invite page, in milestone order. Thunked so
// content names resolve against the locale set by setup.ts, not import order.
const MILESTONE_VISUALS: (() => RewardVisual)[] = [
  () => ({ kind: 'coins', amount: 500 }),
  () => ({ kind: 'coins', amount: 1500 }),
  () => ({ kind: 'gems', amount: 88 }),
  () => ({ kind: 'content', name: m.invite_page_prize_tree() }),
  () => ({ kind: 'content', name: m.invite_page_prize_land() }),
]

/** Looks up the visual for a milestone position; `undefined` out of range. */
export function rewardVisual(index: number): RewardVisual | undefined {
  return MILESTONE_VISUALS[index]?.()
}

/**
 * The milestone's client-owned face (visual + artwork) for the reveal's
 * hybrid derivation; `undefined` for positions beyond the hardcoded five.
 */
export function nominalReward(index: number): NominalReward | undefined {
  const visual = rewardVisual(index)
  return visual ? { visual, imageUrl: milestoneRewardImages[index] } : undefined
}
